import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'Row',
  props: {
  lg: Boolean,
  md: Boolean,
  dense: Boolean
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["grid grid-cols-2 md:grid-cols-12 gap-2 md:gap-4 text-gray-200 v-table-row items-center text-xs xs:text-sm lg:text-xs xl:text-sm", {
      'p-3 xs:leading-3': __props.dense,
      'px-6 py-3': __props.lg,
      'px-3 py-3': __props.md,
      'px-3 py-4': !__props.md && !__props.lg && !__props.dense
    }])
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})